import { Button, Stack } from '@mui/material';
import ReactHookFormGenerator from 'Global/ReactHookFormGenerator/ReactHookFormGenerator';
import React from 'react';
import { useForm } from 'react-hook-form';
import { SavePatientDefaultValues } from '../../variables/SavePatientDefualtValues';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { cityCodeModifier } from '../../function/cityCodeModifier';
import { SavePatient } from '../../Adapters/SavePatient';
import useGetAddPatientParam from '../../hooks/useGetAddPatientParam';
import useGenerateFormData from '../../hooks/useGenerateFormData';
import SubmitButton from 'Global/Components/UnEditableComponents/SubmitButton/SubmitButton';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';

const RegistrationForm = ({
  gatheredData,
  formData,
  addPatientParams,
  setShowForm,
  showForm,
  selectedPatient,
  setShowSearchBox,
}) => {
  const { control, formState, handleSubmit } = useForm({
    defaultValues:
      SavePatientDefaultValues(selectedPatient),
  });
  const submitForm_label = FindLangKey(
    'save-patients-for-visit-navbar-title'
  );
  const formSubmitPermission_label = FindLangKey(
    'general-public-add-form-sure'
  );
  const cancelForm_label = FindLangKey(
    'general-public-label-dismiss'
  );

  return (
    <React.Fragment>
      <form
        onSubmit={handleSubmit((data) => {
          const zerofiedValues = Object.fromEntries(
            Object.entries(data).map(([key, value]) => [
              key,
              key.toLowerCase().includes('id') &&
              value === ''
                ? 0
                : value,
            ])
          );

          const frmdata = {
            ...zerofiedValues,
            ...cityCodeModifier(data, addPatientParams),
          };

          SwalAlert(
            'info',
            formSubmitPermission_label,
            true,
            () => {
              SavePatient(
                frmdata,
                setShowForm,
                setShowSearchBox,
                selectedPatient
              );
            }
          );
        })}
      >
        <Stack gap=".5em" mt="1em">
          <ReactHookFormGenerator
            DataArray={formData}
            control={control}
            formState={formState}
          />
          <SubmitButton label={submitForm_label} />
          <Button
            fullWidth
            variant="contained"
            color="colorPrimer"
            sx={{
              color: `${themeColors.ColorPrimary} !important`,
            }}
            onClick={() => {
              setShowForm();
              setShowSearchBox(true);
            }}
          >
            {cancelForm_label}
          </Button>
        </Stack>
      </form>
    </React.Fragment>
  );
};

export default RegistrationForm;
